import React, { useCallback } from 'react';

import { useInternationalization } from '@progress/kendo-react-intl';
import { useTableKeyboardNavigation } from '@progress/kendo-react-data-tools';

import { getNestedValue } from '@progress/kendo-react-treelist';
import { classNames, IconWrap, Keys } from '@progress/kendo-react-common';
import capitalizeFirstLetter from '../../../../../common/utility/capitalizeFirstLetter';
import { caretAltRightIcon, caretAltDownIcon } from '@progress/kendo-svg-icons';

import DocumentNameCell from '../documentNameCell/documentNameCell';

const TreeListCell = (props) => {
  const { level = [0], expanded, dataItem, format, id, ariaColumnIndex } = props;
  const data = getNestedValue('name', dataItem);
  const intl = useInternationalization();
  const navigationAttributes = useTableKeyboardNavigation(id);
  let dataAsString = '';
  const prefix = dataItem.type && <span className='treelist-prefix'>{capitalizeFirstLetter(dataItem.type + ' ')}</span>;

  const onKeyDownHandler = useCallback(
    (event) => {
      if (event.isDefaultPrevented()) {
        return;
      }

      if (event.keyCode === Keys.enter && props.expandable) {
        event.preventDefault();
        props.onExpandChange(event, dataItem, level);
      }
    },
    [props.expandable, dataItem, level],
  );

  if (data !== undefined && data !== null) {
    dataAsString = format ? intl.format(format, data) : data.toString();
  }

  const icons: Array<any> = [];
  if (props.expandable) {
    icons.push(...level.slice(1).map((_x, i) => <div className='k-i-none' key={i}> </div>));

    if (dataItem.documentId === undefined) {
      icons.push(
        <IconWrap
          key='expand-collapse'
          name={expanded ? 'caretAltDown' : 'caretAltRight'}
          icon={expanded ? caretAltDownIcon : caretAltRightIcon}
        />,
      );
    } else {
      icons.push(<div className='k-i-none' key={icons.length}> </div>);
    }
  }

  const defaultRendering = (
    <td
      style={props.style}
      className={classNames(props.className, {
        ['k-text-nowrap']: props.expandable,
      })}
      colSpan={props.colSpan}
      aria-colindex={ariaColumnIndex}
      role={'gridcell'}
      onClick={(event) => props.onExpandChange(event, dataItem, level)}
      onKeyDown={onKeyDownHandler}
      title={`${dataAsString}`}
      {...navigationAttributes}>
      <div className='treelist-expand-cell-wrapper'>
        {icons}
        {prefix}
        <span className={`${dataItem.documentId === undefined ? 'treelist-header-text' : ''}`}>{dataAsString}</span>
      </div>
    </td>
  );

  return dataItem.documentId !== undefined ? (
    <DocumentNameCell {...props} icon={icons} origin='documentsPage' />
  ) : props.render ? (
    props.render.call(undefined, defaultRendering, props)
  ) : (
    defaultRendering
  );
};

TreeListCell.displayName = 'KendoReactTreeListCell';

export default TreeListCell;
